<section class="wrapper">
  <app-infoscreen-header
    [date]="date()"
    [spinnerState]="spinnerState()"
    [progressValue]="progressValue()"
  ></app-infoscreen-header>

  <div #tableContainer class="scrollable-content-wrapper">
    @if (!hasLocationId()) {
      <app-error-message></app-error-message>
    } @else if (view() !== 'list') {
      @if (from()) {
        <app-calendar-view
          class="timetable"
          [periods]="periods()"
          [viewType]="view() === 'week' ? 'WeekCalendar' : 'DayCalendar'"
          [from]="from()"
          [now]="date()"
          [cardFields]="view() === 'week' ? weekFields : dayFields"
        />
      }
    } @else {
      <div
        class="scroll-content"
        [class.ready]="isReady()"
        [class.scrolling]="shouldScroll()"
        [class.refreshing]="isRefreshing()"
        [style.--scroll-duration.s]="scrollDurationSeconds()"
      >
        <!-- First table instance -->
        <app-activity-table
          [dataSource]="dataSource"
          [displayedColumns]="displayedColumns"
          [displayDate]="date()"
        />

        <!-- Duplicate table for seamless infinite scroll -->
        @if (shouldScroll()) {
          <app-activity-table
            [dataSource]="dataSource"
            [displayedColumns]="displayedColumns"
            [displayDate]="date()"
          />
        }
      </div>
    }
  </div>

  <app-infoscreen-footer
    [locationName]="locationName()"
  ></app-infoscreen-footer>
</section>
